import { InviteLinkDialog as SharedInviteLinkDialog } from "@tabipla/components";
import {
  useGroupInvitations,
  useCreateInvitation,
  useDeleteInvitation,
} from "../../application/hooks/useInvitations";

interface InviteLinkDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  groupId: string;
  groupName?: string;
}

export function InviteLinkDialog({
  open,
  onOpenChange,
  groupId,
  groupName,
}: InviteLinkDialogProps) {
  const { data: invitations, isLoading } = useGroupInvitations(groupId);
  const createMutation = useCreateInvitation(groupId);
  const deleteMutation = useDeleteInvitation(groupId);

  return (
    <SharedInviteLinkDialog
      open={open}
      onOpenChange={onOpenChange}
      groupName={groupName}
      invitations={invitations}
      isLoading={isLoading}
      onCreateInvitation={createMutation.mutateAsync}
      isCreating={createMutation.isPending}
      onDeleteInvitation={deleteMutation.mutateAsync}
      isDeleting={deleteMutation.isPending}
      // Tabitto-specific messages (travel planning)
      templateMessage={`「{{groupName}}」の旅行プランに参加してね！\n\n登録不要・30秒で参加できるよ👇\n{{url}}`}
      templateMessageNoGroup={`旅行プランに参加してね！\n\n登録不要・30秒で参加できるよ👇\n{{url}}`}
    />
  );
}
